// src/App.js
import React, { useState } from 'react';
import FloorPlanGenerator from './components/FloorPlanGenerator';
import FloorPlanGenerator3D from './components/FloorPlanGenerator3D';
import './App.css';

function App() {
  const [is3D, setIs3D] = useState(false);

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>{is3D ? '3D' : '2D'} Township Planner</h1>
        <ViewToggle is3D={is3D} onToggle={setIs3D} />
      </header>
      
      <main className="app-main">
        {is3D ? <FloorPlanGenerator3D /> : <FloorPlanGenerator />}
      </main>
      
      <footer className="app-footer">
        <p>Created with React Three Fiber • Township Planner v2.0</p>
      </footer>
    </div>
  );
}

const ViewToggle = ({ is3D, onToggle }) => (
  <div className="view-toggle-container">
    <span className={`view-label ${!is3D ? 'active' : ''}`}>2D</span>
    <div className="toggle-switch">
      <input
        type="checkbox"
        id="view-mode"
        checked={is3D}
        onChange={(e) => onToggle(e.target.checked)}
        className="toggle-input"
      />
      <label htmlFor="view-mode" className="toggle-label">
        <span className="toggle-button"></span>
      </label>
    </div>
    <span className={`view-label ${is3D ? 'active' : ''}`}>3D</span>
  </div>
);

export default App;